var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M18,21v2H0V21Zm-2.29-8.29-1.42-1.42L10,15.59V0H8V15.59l-4.29-4.3L2.29,12.71,9,19.41Z"}})}
var staticRenderFns = []

export { render, staticRenderFns }